module.exports = __webpack_public_path__ + "2185359a5d6d1de78a304bd5f4cba90d.svg";